import * as types from "../types/site.config.types";

const initialState = {
  initialData: [],
  initialLoading: false,
  initialPagination: [],
  initialFilter: {
    page: 1,
    limit: 10,
  },
  initialSingle: [],
};

const SiteConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SITE_CONFIG_DATA:
      return { ...state, initialData: action.payload };
    case types.SET_SITE_CONFIG_LOADING:
      return { ...state, initialLoading: action.payload };
    case types.SET_SITE_CONFIG_PAGINATION:
      return { ...state, initialPagination: action.payload };
    case types.SET_SITE_CONFIG_FILTER:
      return { ...state, initialFilter: action.payload };
    case types.SET_SITE_CONFIG_SINGLE:
      return { ...state, initialSingle: action.payload };
    case types.RESET_SITE_CONFIG_REDUCER:
      return {
        ...state,
        initialData: [],
        initialLoading: false,
        initialPagination: [],
        initialFilter: {
          page: 1,
          limit: 10,
        },
        initialSingle: [],
      };
    default:
      return state;
  }
};

export default SiteConfigReducer;
